import { css } from '@emotion/react';
import { belowHugeMobile } from '../../../styles';
import { SecondaryProps, p2r } from '../../../styles/fonts';

const styles = ({ maxWidth, width, fontSize, lineHeight, fontWeight, letterSpacing }) => css`
  width: ${width};
  max-width: ${maxWidth};
  margin: 0;
  font-size: ${p2r(fontSize)};
  font-weight: ${fontWeight};
  line-height: ${p2r(lineHeight)};
  letter-spacing: ${p2r(letterSpacing)};
  ${SecondaryProps}

  ${belowHugeMobile(`
    width: 100%;
  `)}
`;

export default styles;
